import { useSignupClick } from '@/provider/useSignupClick'

export function GuestSaveBanner() {
  const { signupUrl, onSignupClick } = useSignupClick()

  return (
    <div className="max-w-xl mx-auto mt-3 rounded-lg border border-primary/25 bg-primary/8 px-4 py-3 text-sm text-muted-foreground flex items-center justify-between gap-3">
      <span>Running as a guest — results live at a shareable link.</span>
      <a
        href={signupUrl}
        onClick={() => onSignupClick('guest_banner')}
        className="text-primary whitespace-nowrap"
      >
        Sign up on VWAM to save your runs →
      </a>
    </div>
  )
}
